// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"8471f734","230":"b2b40bbd","368":"9ce403a2","956":"dbf145eb","961":"9314d485"}[chunkId] + ".chunk.css";
};